import React from "react";
import { Select, DatePicker, Input } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import images from "../../assets";
import PrimaryButton from "../button/primarybutton";
const onChange = (date, dateString) => {
  console.log(date, dateString);
};

export default function MyAccountInfo() {
  return (
    <div>
      <div className="w-[270px] my-4 ml-12 bg-[#ebedf0] rounded-lg justify-between items-center inline-flex">
        <div className="tab-container">
          <div key="1" className="tab-menu active">
            My Account
          </div>
          <div key="2" className="tab-menu">
            Security & Preferences
          </div>
        </div>
      </div>
      <div className="w-full bg-white rounded-2xl border border-primary50 ">
        <div className="w-full p-8 flex flex-row justify-between">
          <div className="w-[518px] flex-col justify-start items-start gap-[46px] inline-flex">
            <div className="w-full h-[388px] flex-col justify-start items-start gap-4 flex">
              <h3 className="text-basePrimary text-base font-semibold  leading-normal">
                My Account
              </h3>
              <div className="self-stretch h-[348px] flex-col justify-start items-start gap-3 flex">
                <div className="self-stretch justify-start items-start gap-2 inline-flex">
                  <div className="w-full flex-col justify-start items-start gap-2 inline-flex">
                    <p>First Name:</p>
                    <Input style={{ height: 48 }} placeholder="First Name" />
                  </div>
                  <div className="w-full flex-col justify-start items-start gap-2 inline-flex">
                    <p>Last Name:</p>
                    <Input style={{ height: 48 }} placeholder="Last Name" />
                  </div>
                </div>
                <div className="self-stretch flex-col justify-start items-start gap-2 flex">
                  <div className="self-stretch justify-between items-center inline-flex">
                    <div className="text-center">
                      <p className="text-[#222222] text-base font-normal  leading-tight">
                        I am a<span className="text-[#f31260]">*</span>
                      </p>
                    </div>
                    <PrimaryButton
                      style={{
                        height: "24px",
                        width: "110px",
                        fontSize: "16px",
                        background: "#f8e6ef",
                        color: "#be0f6a",
                        gap: "2px",
                      }}
                      text={"Change"}
                      iconalign="left"
                      icon={images.editIcon2}
                    />
                  </div>
                  <div className="w-full justify-between items-center inline-flex">
                    <Select
                      showSearch
                      style={{
                        width: "100%",
                        height: 48,
                      }}
                      placeholder="Please Select"
                      options={[
                        {
                          value: "1",
                          label: "Male",
                        },
                        {
                          value: "2",
                          label: "Female",
                        },
                        {
                          value: "3",
                          label: "Other",
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="self-stretch h-[76px] flex-col justify-start items-start gap-2 flex">
                  <div className="text-center">
                    <p className="text-[#222222] text-base font-normal  leading-tight">
                      Date of Birth<span className="text-[#f31260]">*</span>
                    </p>
                  </div>
                  <DatePicker
                    style={{
                      width: "100%",
                      height: 48,
                    }}
                    onChange={onChange}
                  />
                </div>
                <div className="self-stretch h-20 flex-col justify-start items-start gap-2 flex">
                  <div className="self-stretch justify-between items-center inline-flex">
                    <div className="text-center">
                      <p className="text-[#222222] text-base font-normal  leading-tight">
                        Phone
                        <span className="text-[#f31260]">*</span>
                      </p>
                    </div>
                    <PrimaryButton
                      style={{
                        height: "24px",
                        width: "110px",
                        fontSize: "16px",
                        background: "#f8e6ef",
                        color: "#be0f6a",
                        gap: "2px",
                      }}
                      text={"Change"}
                      iconalign="left"
                      icon={images.editIcon2}
                    />
                  </div>
                  <div className="self-stretch justify-start items-start inline-flex">
                    <div className="w-full justify-start items-center flex">
                      <PhoneInput
                        style={{
                          width: "100%",
                          height: "48px",
                          background: "#f3f3fa",
                          borderRadius: "8px",
                        }}
                        country={"bd"}
                        className="user-profile-phone"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="self-stretch h-[185px] flex-col justify-start items-start gap-10 flex">
              <div className="self-stretch h-20 flex-col justify-start items-start gap-2 flex">
                <div className="self-stretch justify-between items-center inline-flex">
                  <div>
                    <p className="text-[#222222] items-start flex flex-col gap-2 text-base font-normal  leading-tight">
                      Email <br />{" "}
                      <span className="text-xs">
                        The email address associated with your account.
                      </span>
                    </p>
                  </div>
                  <PrimaryButton
                    style={{
                      height: "24px",
                      width: "110px",
                      fontSize: "16px",
                      background: "#f8e6ef",
                      color: "#be0f6a",
                      gap: "2px",
                    }}
                    text={"Change"}
                    iconalign="left"
                    icon={images.editIcon2}
                  />
                </div>
                <div className="w-full h-12 justify-between items-center inline-flex">
                  <Input style={{ height: 48 }} placeholder="Email" />
                </div>
              </div>
              <div className="self-stretch justify-between items-center inline-flex">
                <div className="flex-col justify-start items-start gap-2 inline-flex">
                  <p className="text-[#222222] text-base font-semibold  leading-tight">
                    Password
                  </p>
                  <p className="text-[#222222]/60 text-xs font-normal  leading-[18px]">
                    Set a unique password to protect your account.
                  </p>
                </div>
                <PrimaryButton
                  style={{
                    height: "40px",
                    width: "170px",
                    fontSize: "16px",
                    background: "#f8e6ef",
                    color: "#be0f6a",
                    gap: "2px",
                  }}
                  text={"Change Password"}
                />
              </div>
            </div>
          </div>
          <div className="w-[360px] h-80 p-4 bg-white rounded-2xl shadow border border-primary50 flex-col justify-start items-center gap-6 inline-flex">
            <h3 className="self-stretch text-center text-basePrimary text-base font-semibold  leading-normal">
              Profile Photo
            </h3>
            <div className="w-[196px] h-[196px] px-5 py-[9px] justify-start items-center gap-2.5 inline-flex">
              <div className="w-[196px] h-[196px] relative">
                <div className="w-[196px] h-[196px] left-0 top-0 rounded-full absolute border-2 border-basePrimary">
                  <img
                    className="w-full rounded-full"
                    src={images.userProfile2}
                  />
                </div>
              </div>
              <div className="w-[34px] h-[34px] relative">
                <div className="w-[34px] h-[34px] left-6 top-16 absolute bg-secondary rounded-full">
                  <img
                    className="mt-1.5 ml-1.5 rounded-full"
                    src={images.cameraIcon}
                  />
                </div>
              </div>
            </div>
            <p className="self-stretch text-center text-[#222222] text-sm font-normal  leading-tight">
              (Supported formats: JPG, PNG. Max size: 5MB)
            </p>
          </div>
        </div>
        <div className="flex my-8 items-center justify-center">
          <PrimaryButton
            style={{
              width: "277px",
              height: "48px",
              fontSize: "14px",
            }}
            text={"Save"}
          />
        </div>
      </div>
    </div>
  );
}
